<template>
  <div style="height:100%">
    <navHeader :menuItems="headerMenu" />
    <sideMenu :toggleLeft="sideMenuToggle" :toggleRight="sideUserMenuToggle">
      <template v-slot:left>
        <navSide :menuItems="sideMenuLeft" />
      </template>
      <template v-slot:right>
        <navSideMenu :menuItems="sideMenuRight" />
      </template>
    </sideMenu>
    <navSide :menuItems="sideMenuLeft" class="d-none d-md-block" />
    <div class="page">
      <vue-scroll :ops="scrollBar">
        <router-view />
      </vue-scroll>
    </div>
  </div>
</template>

<script>
import navHeader from "@/components/navigation/nav-header.vue";
import navSide from "@/components/navigation/nav-side.vue";
import sideMenu from "@/components/side-menu.vue";
import navSideMenu from "@/components/navigation/nav-side-menu.vue";
import shebahApi from "@/services/shebah/index";

export default {
  name: "default",
  components: {
    navHeader,
    navSide,
    sideMenu,
    navSideMenu
  },
  computed: {
    authUser() {
      return this.$store.getters["authUser/user"];
    },
    isNewUser() {
      return this.$store.getters["authUser/isNewUser"];
    },
    alerts() {
      return this.$store.getters["authUser/alerts"];
    },
    scrollBar() {
      return this.$store.getters["general/scrollbar"];
    },
    sideMenuToggle() {
      return this.$store.getters["general/sideMenu"];
    },
    sideUserMenuToggle() {
      return this.$store.getters["general/sideUserMenu"];
    },
    isAdvancedBookingFreeze() {
      return this.authUser.isAdvancedBookingFreeze;
    },
    headerMenu() {
      let headerMenu = [
        {
          title: this.authUser.status,
          type: "status",
          class: (() => {
            let classStyle = {};
            switch (this.authUser.status) {
              case "incomplete":
                classStyle = { "text-info": true };
                break;
              case "pending":
                classStyle = { "text-warning": true };
                break;
              case "active":
                classStyle = { "text-success": true };
                break;
              case "suspended":
                classStyle = { "text-danger": true };
                break;
            }
            return classStyle;
          })(),
          badge: "",
          icon: "circle",
          variant: "primary",
          avatar: this.avatar,
          route: ""
        },
        {
          title: `Hi ${this.authUser.firstName}!`,
          type: "profile",
          badge: "",
          icon: "user-circle",
          variant: "secondary",
          avatar: this.avatar,
          route: "",
          subMenu: [
            {
              title: "Personal",
              route: "/profile/personal",
              icon: "user"
            },
            {
              title: "Business Details",
              route: "/profile/business-details",
              icon: "wallet"
            },
            {
              title: "BAS Statements",
              route: "/profile/bas-statements",
              icon: "file-alt"
            },
            {
              type: "divider"
            },
            {
              title: "Sign Out",
              route: "/sign-in",
              icon: "power-off"
            }
          ]
        },
        // {
        //   title: 'Notifications',
        //   type: 'update',
        //   badge: 2,
        //   icon: 'bell',
        //   route: '',
        //   variant: 'primary',
        //   subMenu: [
        //     {
        //       title: 'New update',
        //       description: 'New driver iOs & Android App in stores',
        //       route: '',
        //       icon: 'envelope'
        //     },
        //   ]
        // },
        {
          title: "Need Attention",
          type: "update",
          badge: this.alerts.length,
          icon: "exclamation-circle",
          route: "",
          variant: "secondary",
          subMenu: (() => {
            return this.alerts;
          })()
        },
        {
          title: "",
          type: "settings",
          badge: "",
          icon: "cogs",
          variant: "primary",
          avatar: this.avatar,
          route: "",
          subMenu: (() => {
            let options = [
              {
                title: "Contact support to activate Advance Bookings"
                // value: '',
                // action: null
              }
            ];

            if (!this.isAdvancedBookingFreeze) {
              options = [
                {
                  title: "Advance Bookings",
                  value: (() => {
                    return typeof this.authUser.acceptsAdvancedBooking !==
                      "undefined"
                      ? this.authUser.acceptsAdvancedBooking
                      : false;
                  })(),
                  action: value => {
                    shebahApi.api.users.update({
                      acceptsAdvancedBooking: value
                    });
                  }
                },
                {
                  title: "Advance Bookings Offline",
                  value: (() => {
                    return typeof this.authUser
                      .acceptsAdvancedBookingOffline !== "undefined"
                      ? this.authUser.acceptsAdvancedBookingOffline
                      : false;
                  })(),
                  action: value => {
                    shebahApi.api.users.update({
                      acceptsAdvancedBookingOffline: value
                    });
                  }
                }
              ];
            }
            return options;
          })()
        }
      ];

      return headerMenu;
    },
    sideMenuLeft() {
      return {
        groupOne: [
          {
            title: "Menu"
          },
          {
            title: "Dashboard",
            badge: "",
            icon: "tachometer-alt",
            route: "/"
            // subMenu: [
            //   {
            //     route: '/',
            //     title: 'Dashboard 1',
            //     active: false,
            //   }
            // ]
          },
          {
            title: "Documents",
            badge: "",
            icon: "folder-open",
            route: "",
            subMenu: [
              {
                route: "/documents/driver",
                title: "Driver"
              },
              {
                route: "/documents/vehicles",
                title: "Vehicles"
              }
            ]
          },
          {
            title: "Compliance",
            badge: "",
            icon: "file-contract",
            route: "",
            subMenu: [
              {
                route: "/compliance/questionnaire",
                title: "Questionnaire"
              },
              {
                route: "/compliance/assets",
                title: "Assets"
              }
            ]
          },
          // {
          //   title: 'BAS statements',
          //   badge: '',
          //   icon: 'file-invoice',
          //   route: 'bas-statement'
          // },
          // {
          //   title: 'Bank Details',
          //   badge: '',
          //   icon: 'wallet',
          //   route: 'bank-details'
          // },
          {
            title: "Resources",
            badge: "",
            icon: "file-medical",
            route: "",
            subMenu: [
              // {
              //   route: '/support-forms/incorrect-trip',
              //   title: 'Policies',
              //   active: false,
              // },
              {
                route: "/support-forms/incorrect-trip",
                title: "Incorrect Trip form",
                active: false
              },
              {
                route: "/support-forms/app-issues",
                title: "App Issues form",
                active: false
              },
              {
                route: "/promotions",
                title: "Promotions",
                active: false
              }
            ]
          }
          // {
          //   title: 'Driver FAQ',
          //   badge: '',
          //   icon: 'question-circle',
          //   route: '/resources'
          // }
        ]
      };
    },
    sideMenuRight() {
      let headerMenu = [
        {
          title: this.authUser.status,
          type: "status",
          class: (() => {
            let classStyle = {};
            switch (this.authUser.status) {
              case "incomplete":
                classStyle = { "text-info": true };
                break;
              case "pending":
                classStyle = { "text-warning": true };
                break;
              case "active":
                classStyle = { "text-success": true };
                break;
              case "suspended":
                classStyle = { "text-danger": true };
                break;
            }
            return classStyle;
          })(),
          badge: "",
          icon: "circle",
          variant: "primary",
          avatar: this.avatar,
          route: ""
        },
        {
          title: `Hi ${this.authUser.firstName}!`,
          type: "profile",
          badge: "",
          icon: "user-circle",
          variant: "secondary",
          avatar: this.avatar,
          route: "",
          subMenu: [
            {
              title: "Personal",
              route: "/profile/personal",
              icon: "user"
            },
            {
              title: "Business Details",
              route: "/profile/business-details",
              icon: "wallet"
            },
            {
              title: "BAS Statements",
              route: "/profile/bas-statements",
              icon: "file-alt"
            }
          ]
        },
        // {
        //   title: 'Notifications',
        //   type: 'update',
        //   badge: 2,
        //   icon: 'bell',
        //   route: '',
        //   variant: 'primary',
        //   subMenu: [
        //     {
        //       title: 'New update',
        //       description: 'New driver iOs & Android App in stores',
        //       route: '',
        //       icon: 'envelope'
        //     },
        //   ]
        // },
        {
          title: "Need Attention",
          type: "update",
          badge: this.alerts.length,
          icon: "exclamation-circle",
          route: "",
          variant: "secondary",
          subMenu: (() => {
            return this.alerts;
          })()
        },
        {
          title: "Options",
          expand: true,
          type: "settings",
          badge: "",
          icon: "cogs",
          variant: "primary",
          avatar: this.avatar,
          route: "",
          subMenu: [
            {
              title: "Advance Bookings",
              value: (() => {
                return typeof this.authUser.acceptsAdvancedBooking !==
                  "undefined"
                  ? this.authUser.acceptsAdvancedBooking
                  : false;
              })(),
              action: value => {
                shebahApi.api.users.update({
                  acceptsAdvancedBooking: value
                });
              }
            },
            {
              title: "Advance Bookings Offline",
              value: (() => {
                return typeof this.authUser.acceptsAdvancedBookingOffline !==
                  "undefined"
                  ? this.authUser.acceptsAdvancedBookingOffline
                  : false;
              })(),
              action: value => {
                shebahApi.api.users.update({
                  acceptsAdvancedBookingOffline: value
                });
              }
            }
          ]
        },
        {
          type: "divider"
        },
        {
          title: "Sign Out",
          type: "",
          badge: "",
          icon: "power-off",
          variant: "primary",
          avatar: this.avatar,
          route: "/sign-in"
        }
      ];

      return {
        group1: headerMenu
      };
    }
  },
  data() {
    return {};
  },
  created() {
    this.loadGTM();
    this.googleAnalytics();
    // this.verizon();
      if (this.isNewUser) {
        this.$store.dispatch("authUser/setNewUser", false);
        var dataObject = {
          event: "newDriverSignup",
          value: "userSignUp",
        };
        if (typeof dataLayer != "undefined") {
          dataLayer.push(dataObject);
        }
      }
  },

  methods: {
    loadGTM(callback) {
      var script = document.createElement("script");
      script.type = "text/javascript";
      script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-PN4TQQP');`;
      document.getElementsByTagName("head")[0].appendChild(script);
    },
    googleAnalytics() {
      var script = document.createElement("script");
      script.type = "text/javascript";
      script.innerHTML = ` window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'UA-83214466-4');`;
      document.getElementsByTagName("head")[0].appendChild(script);
    },
    verizon() {
      var script = document.createElement("script");
      script.type = "text/javascript";
      script.innerHTML = `(function(w,d,t,r,u){w[u]=w[u]||[];w[u].push({'projectId':'10000','properties':{'pixelId':'10099307'}});
      var s=d.createElement(t);s.src=r;s.async=true;s.onload=s.onreadystatechange=function(){var y,rs=this.readyState,c=w[u];
      if(rs&&rs!="complete"&&rs!="loaded"){return}try{y=YAHOO.ywa.I13N.fireBeacon;w[u]=[];w[u].push=function(p){y([p])};y(c)}catch(e){}};
      var scr=d.getElementsByTagName(t)[0],par=scr.parentNode;par.insertBefore(s,scr)})(window,document,"script","https://s.yimg.com/wi/ytc.js","dotq");`;

      script.onload = () => {};
      document.getElementsByTagName("head")[0].appendChild(script);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.page {
  height: 100%;
}
</style>
